import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-resize-handler",
  "use": "icon-resize-handler-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-resize-handler\"><g clip-path=\"url(#icon-resize-handler_a)\"><path stroke=\"#979ca6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"m7.5 1.5-6 6m13-6-13 13\" /></g><defs><clipPath id=\"icon-resize-handler_a\"><path fill=\"#fff\" d=\"M16 16V0H0v16z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol